module.exports = __webpack_public_path__ + "static/img/play.253be04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/play.png
// module id = zh3l
// module chunks = 1